// pages/Login/LoginSelect2FA.tsx
import React from 'react';
import { Card, ChevronRightIcon, Col, Container, EnvelopeIcon, PhoneVolumeIcon, Row, TwoIconTextButton } from 'shared-portal-component';

import { useAuth2FASelect } from '@/hooks/auth/useAuth2FASelect';
import type { TwoFactorMethod } from '@/types/auth/Auth';
import AuthBodyText from '@/components/atomic/AuthBodyText/AuthBodyText';
import AuthHeaderText from '@/components/atomic/AuthHeaderText/AuthHeaderText';

/**
 * /login/2fa/select route
 * 2FA method selection (SMS or Email)
 */
const LoginSelect2FA: React.FC = () => {
  const { handlers, state: { maskedEmail, maskedPhone } } = useAuth2FASelect();
  const onSelect = (method: TwoFactorMethod) => {
    void handlers.selectMethod(method);
  }
  return (
<Container fluid>
    <Card>
      <Row spacing="md">
        <Col size={12}>
          <AuthHeaderText text='Choose your second authentication method'/>
          <AuthBodyText text='Please select one of the methods below and we will send a 6-digit code to the selected location.' />
        </Col>
      </Row>
      <Row spacing="md" className='gap-4'>
        <Col size={12}>
          <TwoIconTextButton
            leftIcon={<PhoneVolumeIcon />}
            text={`We will text the code to the number on your account ending in ${maskedPhone}`}
            rightIcon={<ChevronRightIcon />}
            variant="outline"
            size="sm"
            className="w-full"
            onClick={() => { onSelect('sms'); }}
          />
        </Col>
        <Col size={12}>
          <TwoIconTextButton
            leftIcon={<EnvelopeIcon />}
            text={`We will send the code to your email address ${maskedEmail}`}
            rightIcon={<ChevronRightIcon />}
            variant="outline"
            size="sm"
            className="w-full"
            onClick={() => { onSelect('email'); }}
          />
        </Col>
      </Row>
    </Card>
  </Container>  );
};

export default LoginSelect2FA;
